import extend from '@/utils/vuex-extend';
import { dialog } from '@/vuex-extend';
import { getOrderDetail } from '@/api/pcm/order';
import { wait } from '@/utils/wait';
import {getAllDepotList} from "@/api/sms/arrival-order";

export default extend(dialog, {
	namespaced: true,
	state: {
		form: {},
		depotList: []
	},
	actions: {
		async afterOpenDialog({ dispatch, commit }, payload) {
			await wait(dispatch, 'pcm.order.import-order', async function() {
				const response = await getAllDepotList();
				console.log(response.data)
				if (response.data) {
					commit('save', {
						depotList: response.data
					})
				}
			})
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/pcm/order/import-order.js